import React, { useEffect, useState } from 'react'
import {
  GoogleMapMarker,
  GoogleMapOptions,
  GoogleMapProps
} from './GoogleMap.types'
import {
  GoogleMap as GoogleMapRenderer,
  Marker,
  LoadScript,
  Autocomplete,
  InfoWindow
} from '@react-google-maps/api'

const containerStyle = {
  height: '100%',
  width: '100%',
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'center',
  padding: 0
}

const defaultOptions: GoogleMapOptions = {
  zoomControl: true,
  fullscreenControl: false,
  mapTypeControl: false,
  streetViewControl: false
}

const libraries: any[] = ['places']

const GoogleMap = ({
  className,
  APIkey,
  marks,
  initialCenter,
  initialZoom,
  options,
  autoCompleteInput,
  infoView,
  onAutoCompleteLoad,
  onAutoCompletePlaceChanged,
  onMarkerMouseOver,
  onMarkerClick,
  onCenterChanged
}: GoogleMapProps) => {
  const [mapRef, setMapRef] = useState<google.maps.Map>()
  const [selectedMarkerPosition, setSelectedMarkerPosition] =
    useState<google.maps.LatLngLiteral | null>(null)

  const loadHandler = (map: google.maps.Map) => {
    setMapRef(map)
  }

  const handleCenterChange = () => {
    onCenterChanged && onCenterChanged(mapRef?.getCenter()?.toJSON())
  }

  const handleMarkerClick = (
    position: google.maps.LatLngLiteral,
    data: object | undefined
  ) => {
    if (data) {
      setSelectedMarkerPosition(position)
      onMarkerClick && onMarkerClick(data)
    } else {
      setSelectedMarkerPosition(null)
    }
  }

  const fitBounds = (map: google.maps.Map) => {
    const bounds = new window.google.maps.LatLngBounds()
    marks?.map((place) => bounds.extend(place.position))
    map.fitBounds(bounds)
  }

  useEffect(() => {
    if (mapRef) {
      fitBounds(mapRef)
    }
  }, [marks])

  return (
    <div className={className}>
      <LoadScript googleMapsApiKey={APIkey} libraries={libraries}>
        <GoogleMapRenderer
          onLoad={loadHandler}
          mapContainerStyle={containerStyle}
          onCenterChanged={handleCenterChange}
          center={initialCenter}
          zoom={initialZoom}
          options={options || defaultOptions}
        >
          {autoCompleteInput && (
            <Autocomplete
              onLoad={onAutoCompleteLoad}
              onPlaceChanged={onAutoCompletePlaceChanged}
            >
              {autoCompleteInput}
            </Autocomplete>
          )}

          {marks?.map((place: GoogleMapMarker) => (
            <Marker
              onMouseOver={
                onMarkerMouseOver && (() => onMarkerMouseOver(place.id))
              }
              onClick={() => handleMarkerClick(place.position, place.data)}
              key={place.id}
              icon={place.icon}
              position={place.position}
            />
          ))}
          {selectedMarkerPosition && infoView && (
            <InfoWindow
              position={{
                lat: selectedMarkerPosition.lat,
                lng: selectedMarkerPosition.lng
              }}
              onCloseClick={() => setSelectedMarkerPosition(null)}
            >
              {infoView}
            </InfoWindow>
          )}
        </GoogleMapRenderer>
      </LoadScript>
    </div>
  )
}

export default GoogleMap
